// extracted by mini-css-extract-plugin
export var description = "OfficeCard-module--description--66925";
export var fadeInAnimation = "OfficeCard-module--fadeInAnimation--4f025";
export var link = "OfficeCard-module--link--2416c";
export var title = "OfficeCard-module--title--6ec1f";
export var wrapper = "OfficeCard-module--wrapper--c9133";